import { AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';
import { TooltipProps, tooltipStyles, useTooltip, confirmTooltipPosition } from '@kite_aerolab/shared/components';
import { getBreakpoint } from '@kite_aerolab/shared/utils';

@Component({
  selector: 'kite-tooltip',
  templateUrl: './tooltip.component.html',
})
export class TooltipComponent implements AfterViewInit {
  @Input() variant: TooltipProps['variant'];
  @Input() ariaLabel: TooltipProps['ariaLabel'];
  @Input() css: TooltipProps['css'];
  @Input() isTitleHidden: TooltipProps['isTitleHidden'];
  @Input() isOpen = false;

  @ViewChild('containerRef') containerRef: ElementRef;
  @ViewChild('cardRef') cardRef: ElementRef;
  @ViewChild('childrenRef') childrenRef: ElementRef;
  @ViewChild('pointerRef') pointerRef: ElementRef;
  forcedPosition: TooltipProps['position']
  openOn: TooltipProps['openOn'] = 'click';


  _breakpoint = getBreakpoint()
  @Input() get breakpoint () {
    return this._breakpoint
  }
  set breakpoint(val: string) {
    this._breakpoint = val;
  }
  constructor(private renderer: Renderer2) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.isRemovable) {
        if (!this.childrenRef.nativeElement.contains(e.target)) {
          this.isOpen = false;
        }
      }
    });
    this.renderer.listen('window', 'resize',() => {
      this.changeBreakpoint()
    });
    this.renderer.listen('window', 'scroll',() => {
      this.setTooltipPosition()
    });
  }

  _position: TooltipProps['position'];
  @Input() get position() {
    return this._position;
  }

  set position(value: TooltipProps['position']) {
    this._position = value;
    this.setTooltipPosition();
  }

  _title: TooltipProps['title'];
  @Input() get title() {
    return this._title;
  }

  set title(value: TooltipProps['title']) {
    this._title = value;
    this.setTooltipPosition();
  }

  _description: TooltipProps['description'];
  @Input() get description() {
    return this._description;
  }

  set description(value: TooltipProps['description']) {
    this._description = value;
    this.setTooltipPosition();
  }

  _isRemovable: TooltipProps['isRemovable'];
  @Input() get isRemovable() {
    return this._isRemovable;
  }

  set isRemovable(value: TooltipProps['isRemovable']) {
    this._isRemovable = value;
    this.setTooltipPosition();
  }

  setTooltipPosition () {
    if (this.containerRef && this.cardRef) {  
        this.forcedPosition = confirmTooltipPosition(this.containerRef.nativeElement, this.cardRef.nativeElement, this.position)
        this.setTooltipStyles(); 
      }
  }

  ngAfterViewInit () {
    this.forcedPosition = this.position
    this.changeBreakpoint()
    this.setTooltipPosition()
  }

  public get tooltip(): string[] {
    return [
      tooltipStyles({
        variant: this.variant,
        position: this.forcedPosition,
        isRemovable: this.isRemovable,
        isOpen: this.isOpen,
        css: this.css,
      }).className,
    ];
  }

  setTooltipStyles() {
    if (this.containerRef && this.cardRef && this.pointerRef) {
      useTooltip(
        this.containerRef.nativeElement,
        this.cardRef.nativeElement,
        this.pointerRef.nativeElement,
        this.forcedPosition
      );
    }
  }

  toggleOpen() {
    this.isOpen = !this.isOpen;
  }
  changeBreakpoint() {
    this.breakpoint = getBreakpoint();
    this.setTooltipPosition()
  }
}
